/*
represents open-ended JSON object for Communication settings
for MVP the cs1 cachefile is the only setting, but there will be more down the road
*/

import { countries } from "../../../components/localization/LanguageSelector";
import LocalizationSettings from "./LocalizationSettings";
import MediumSettings, { LocationSettingsDataProps } from "./MediumSettings";

class MessageSettings {
    email?: MediumSettings | null;
    sms?: MediumSettings | null;
    app?: MediumSettings | null;

    constructor(
        email: MediumSettings | null,
        sms: MediumSettings | null,
        app: MediumSettings | null
    ) {
        this.email = email;
        this.sms = sms;
        this.app = app;

    }

    // Create a brand new MessageSettings object with all of the localization
    // and medium settings already loaded in for each language this app supports
    public static create = () => {
        const localizationSettingsArrayEmail: Array<LocationSettingsDataProps> = []
        const localizationSettingsArraySMS: Array<LocationSettingsDataProps> = []
        const localizationSettingsArrayApp: Array<LocationSettingsDataProps> = []
        const subject = "Click to edit this communication";
        const messageText = "Replace this message with your own text here!";

        // handle email
        countries.forEach((country) => {
            let localizationSettings = new LocalizationSettings("", "", "")
            if (country.language == 'en') {
                localizationSettings = new LocalizationSettings(subject, messageText, messageText)
            }

            delete localizationSettings.text

            const locationSettingsDataProps = { lang: country.language, localizationSettings: localizationSettings } as unknown as LocationSettingsDataProps
            localizationSettingsArrayEmail.push(locationSettingsDataProps)
        })

        // handle sms
        countries.forEach((country) => {
            let localizationSettings = new LocalizationSettings("", "", "")
            if (country.language == 'en') {
                localizationSettings = new LocalizationSettings(subject, messageText, messageText)
            }

            delete localizationSettings.body
            delete localizationSettings.subject

            const locationSettingsDataProps = { lang: country.language, localizationSettings: localizationSettings } as unknown as LocationSettingsDataProps
            localizationSettingsArraySMS.push(locationSettingsDataProps)
        })

        // handle app
        countries.forEach((country) => {
            let localizationSettings = new LocalizationSettings("", "", "")
            if (country.language == 'en') {
                localizationSettings = new LocalizationSettings(subject, messageText, messageText)
            }

            delete localizationSettings.body
            delete localizationSettings.subject
            
            const locationSettingsDataProps = { lang: country.language, localizationSettings: localizationSettings } as unknown as LocationSettingsDataProps
            localizationSettingsArrayApp.push(locationSettingsDataProps)
        })

        const mediumSettingsEmail = new MediumSettings(localizationSettingsArrayEmail)

        const mediumSettingsSMS = new MediumSettings(localizationSettingsArraySMS)
        const mediumSettingsApp = new MediumSettings(localizationSettingsArrayApp)

        const message = new MessageSettings(mediumSettingsEmail, mediumSettingsSMS, mediumSettingsApp)
        return message;
    }
}

export default MessageSettings;
